import { render } from "./Measure2Point.vue?vue&type=template&id=3a86c034&scoped=true"
import script from "./Measure2Point.vue?vue&type=script&lang=js"
export * from "./Measure2Point.vue?vue&type=script&lang=js"

import "./Measure2Point.vue?vue&type=style&index=0&id=3a86c034&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b6b000019df918e5ba178116dc1dcf84/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a86c034"]])

export default __exports__